// import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Box, Container, SimpleGrid } from "@chakra-ui/react";

export default function GitStats() {
  return (
    <Box
      maxW="7xl"
      mx={"auto"}
      pt={5}
      px={{ base: 2, sm: 12, md: 17 }}
      >
      <Container maxW={"7xl"} py={12}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
          {/* <Center pt={{ base: 4, md: 8 }}> */}
          <img
            id="github-top-langs"
            // align="center"
            src="https://github-readme-stats.vercel.app/api/top-langs?username=omkarSw2&layout=compact&exclude_repo=Lybrate-Website-Clone-Version-2.0,Lybrate-Website-Clone,Adidas-Clone&hide=Shell&border_radius=0&theme=dark"
            alt="omkarSw2"
            width={"100%"}
          />
          <picture>
            <source
              media="(prefers-color-scheme: dark)"
              srcSet="https://streak-stats.demolab.com?user=omkarSw2&theme=dark"
            />
            <img
              id="github-streak-stats"
              src="https://streak-stats.demolab.com/?user=omkarSw2&theme=default%27%20to%20include%20%27github-readme-streak-stats.herokuapp.com"
              alt="omkar-states"
              width={"100%"}
            />
          </picture>
          <img
            id="github-stats-card"
            // align="center"
            src="https://github-readme-stats.vercel.app/api?username=omkarSw2&show_icons=true&include_all_commits=true&count_private=true&hide=issues,contribs&border_radius=0&locale=en&theme=dark"
            alt="omkarSw2"
            width={"100%"}
          />
          {/* <Center width={"100%"} pt={{ base: 4, md: 8 }}> */}
          <GitHubCalendar
            username="omkarSw2"
            className="react-activity-calendar"
            style={{ fontSize: "20px" }}
          />

          {/* </Center> */}
          {/* </Center> */}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
